<docs>
<!--
  <unum-textbox
    name="emailLogin"                        // name attribute on input
    label="test"                             // innerHTML of <label>
    placeholder="Enter your email address"   // placeholder on input
    v-model="loginEmail"                     // data
    v-validate="'required|email'"            // validation rules
    data-vv-value-path="emailLogin"          // need for validate. same as name
    :errorBag="errors"                       // need for validation msg
    :hideLabel="true"                        // custom. hides label
    noMargin="true"
  />
-->
</docs>

<template>
  <div
    :class="{
      'unum-field': true,
      'unum-field--no-margin': noMargin,
      'has-errors': errorBag ? errorBag.has(name) : false
    }"
  >
    <label
      :for="name"
      v-if="label"
      :class="{
        'visuallyhidden': hideLabel
      }"
    >
      {{ label }}
    </label>
    <input
      :type="type ? type : 'text'"
      class="unum-field-textbox"
      autocomplete="off"

      ref="disTextbox"
      :value="value"
      @input="updateValue()"

      :name="name"
      :id="name"
      :placeholder="placeholder"
    />
    <span
      v-if="helpText"
      class="unum-field__help"
    >
      {{ helpText }}
    </span>
    <span
      v-if="errorBag && errorBag.has(name)"
      class="unum-field__help error"
    >
      {{ errorBag.first(name) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'UnumTextbox',
  props: {
    placeholder: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    errorBag: {
      type: Object
    },
    hideLabel: {
      type: Boolean
    },
    noMargin: {
      type: Boolean
    },
    helpText: {
      type: String
    }
  },
  data () {
    return {
      isInValid: false
    }
  },
  methods: {
    updateValue () {
      // console.log(this.$refs.disTextbox.value)
      const trimmed = this.$refs.disTextbox.value.trim()
      this.$emit('input', trimmed)
    }
  }
}
</script>

<style lang="scss">
.unum-field {
  text-align: left;
  width: 100%;
  margin-bottom: 1.5rem;

  label {
    font-weight: 600;
    text-transform: capitalize;
    margin: 0 auto .5rem;
    display: block;
    cursor: pointer;
  }

  &__help {
    font-size: .75rem;
    // margin: -1.25rem 0 .5rem;
    display: block;
    line-height: 1;

    &.error {
      color: #fc9f9f;
    }
  }

  &--no-margin {
    margin: 0 auto;
    .unum-field-textbox {
      margin: 0 auto;
    }
  }

  &.has-errors {
    label {
      color: $red;
    }

    input[type="text"] {
      background: #ffe0e0;
    }
  }
}

.unum-field-textbox {
  padding: 1rem;
  border-radius: 3px;
  border: 0;
  margin: 0 auto .25rem;
  width: 100%;
  border: .063rem solid #ADC5D5;

  &:focus {
    outline: 0;
    border-color: darken(#ADC5D5, 25%);
  }

  .has-errors & {
    border: .063rem solid red;
    color: $red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Textbox.vue